import React from 'react';
import Joi from 'joi';
import Section from 'components/forms/Section';
import {Typography} from '@material-ui/core';
import fields from 'components/forms/ssl/fields';
import {RadioGroup} from 'components/forms/fields';
import {useFieldData} from 'components/forms/hooks';

const options = {
    Oceans: 'Oceans',
    'Near Coastal': 'Near Coastal',
    Inland: 'Inland',
    'Great Lakes': 'Great Lakes',
    'Western Rivers': 'Western Rivers',
};

const schema = {
    watertype: Joi.string().required(),
    also_polar: Joi.string().allow(''),
};
const initialValues = {
    watertype: '',
};

const Watertype = props => {
    const [watertype, setWatertype] = useFieldData('watertype');

    const handleWatertypeChange = event => {
        setWatertype(event.target.value);
    };

    return (
        <Section {...props} {...{schema, initialValues}}>
            <Typography variant='h6' align='left'>
                Route
            </Typography>
            <p></p>
            <RadioGroup
                name={fields.watertype.name}
                label={fields.watertype.label}
                options={options}
                onChange={handleWatertypeChange}
                required
            />
            <p></p>
            {(watertype === 'Oceans' ||
                watertype === 'Near Coastal' ||
                watertype === 'Inland') && (
                <RadioGroup
                    name={fields.also_polar.name}
                    label={fields.also_polar.label}
                    options={{
                        true: 'Yes',
                        false: 'No',
                    }}
                />
            )}
            {props.children}
        </Section>
    );
};

export default Watertype;
